import {useContext, useState} from 'react';
import {UserContext} from "../App"
import {clean} from "./Fonctions"

export function Tuto () {
  document.title = 'Tut\'Automaths'
  const {currentUser} = useContext(UserContext)
  const [search, setSearch] = useState('')

  let tuto = [
    {
      title: 'Quels sont les navigateurs conseillés pour utiliser pleinement Automaths ? ',
      contain: [
        'Automaths est utilisable avec les navigateurs mis à jour régulièrement comme Firefox <img src="https://maths-au-quotidien.fr/images/automaths/tuto_firefox.png" alt="tuto" height="25"  style="vertical-align:middle;border-radius: 50%">, Chrome <img src="https://maths-au-quotidien.fr/images/automaths/tuto_chrome.png" alt="tuto" height="25" style="vertical-align:middle;border-radius: 50%"> ou Opéra <img src="https://maths-au-quotidien.fr/images/automaths/tuto_opera.png" alt="tuto" height="25" style="vertical-align:middle;border-radius: 50%">.',
        'Nous vous déconseillons d\'utiliser Internet Explorer ou Edge pour des raisons d\'incompatibilité.',
        ],
    },
    {
      title: 'J\'ai une page blanche...',
      contain: [
        'Vérifiez que vous n\'utilisez pas un navigateur non compatible (nous conseillons Firefox, Chrome ou Opéra).',
        'Vérifiez que votre connexion internet fonctionne convenablement.',
        'Réactualisez la page (F5 si vous êtes sur PC ou bouton circulaire sur Smartphone ou tablette).',
        'Supprimez vos cookies et données de navigation. Pour cela appuyez sur les touches ctrl+Maj+suppr puis cliquez sur effacer (les cookies et historique doivent être cochés avant de valider).',
        'Testez, si cela est possible, sur un autre appareil que celui que vous utilisez.',
        'Il peut arriver que des navigateurs activent une traduction des pages internet. Dans ce cas, vous pouvez voir affiché <input style="background-color:rgb(186,218,69,0.4); margin:0" type="button" value="Automates" > au lieu de <input style="background-color:rgb(186,218,69,0.4); margin:0" type="button" value="Automaths" >. Dans ce cas, allez dans les paramètres du navigateur et désactivez la traduction automatique des pages.',
        'Il se peut que le problème vienne du site lui-même. Dans ce cas, essayez de vous reconnecter quelques temps après.',
        'Si aucun des points précédents ne règle le problème, vous pouvez nous contacter par message.',
        ],
    },
    {
      title: 'Comment se connecter à la plateforme ?',
      contain: [
        'Cliquer sur le menu en haut à droite, puis sur le bouton "Connexion".<br/> <img class="center" src="https://maths-au-quotidien.fr/images/automaths/tuto1.png" alt="tuto" height="100">',
        'Ensuite, entrer votre identifiant (habituellement sous la forme prenom.nom) ainsi que votre mot de passe.',
        'Une fois connecté.e, vous visualisez votre espace personnel dans lequel sont regroupés tous les résultats obtenus sur le site. <br/> <img class="center" src="https://maths-au-quotidien.fr/images/automaths/tuto5.png" alt="tuto" width="100%"><br/>',
        ],
    },
    {
      title: 'Que faire une fois connecté ?',
      contain: [
        'Sur ordinateur : cliquer sur le bouton vert <img src="https://maths-au-quotidien.fr/images/automaths/tuto6.png" alt="tuto" style="vertical-align:middle;border-radius: 10px"> puis choisir les Notions/Niveau/Nombre de questions.',
        'Sur Smartphone : cliquer sur le "burger menu" <img src="https://maths-au-quotidien.fr/images/automaths/tuto2.png" alt="tuto" height="30" style="vertical-align:middle;border-radius: 10px"> en haut à gauche, <br/>puis sur le bouton vert <img src="https://maths-au-quotidien.fr/images/automaths/tuto6.png" alt="tuto" style="vertical-align:middle;border-radius: 10px"> pour enfin choisir les Notions/Niveau/Nombre de questions.',
        'Dans tous les cas, si votre professeur vous a donné un travail à faire, celui-ci sera affiché dans un post-it.<br> <img class="center" src="https://maths-au-quotidien.fr/images/automaths/post-it.png" alt="tuto" width="40%"><br>Pour faire ce devoir, il suffit de cliquer sur le bouton <input class="btn" type="button" value="Faire ce devoir" >.',
        ],
    },
    {
      title: 'Forcer la deconnexion',
      contain: [
        'Il peut arriver (pour des raisons diverses) que la connexion à l\'espace personnel ne se fasse pas convenablement.<br>Dans ce cas, le logo de chargement reste indéfiniment bloqué.<br> <img class="center" src="https://maths-au-quotidien.fr/images/deconnexion_bug.png" alt="deconnexion" width="100%"><br>Pour vous reconnecter, vous pouvez forcer la deconnexion en cliquant sur le lien <a href="#/logout">Déconnexion</a>.',
        ],
    },
    {
      title: 'Mon professeur n\'a pas reçu ma note...',
      contain: [
        'Vérifiez que vous êtes bien rattaché.e à une classe (dans la partie <b><a href="compte">Mon espace</a></b> vous visualisez votre classe à côté de votre prénom).',
        '&Agrave; la fin de chaque série, vous devez cliquer sur le bouton <img src="https://maths-au-quotidien.fr/images/automaths/tuto_save.png" alt="tuto" height="25" style="vertical-align:middle;border-radius: 10px"> pour qu\'une copie de votre note soit envoyée dans votre espace ainsi que dans celui de votre professeur.',
        'Si ce qui précède ne vous aide pas, faites le point avec votre professeur concernant l\'<b>identifiant/mot de passe</b> que vous utilisez.',
        ],
    },
    {
      title: 'Mes devoirs et mes essais',
      contain: [
        'Lorsque je fais une série donnée par mon professeur et que je la sauvegarde, ma note sera visible dans la partie "<b>Mes devoirs</b>" dans mon espace personnel.',
        'Lorsque je fais une série en choisissant les notions (sans que mon professeur ne me donne de devoir) et que je la sauvegarde, alors ma note sera visible dans la partie "<b>Mes essais</b>" de mon espace personnel.',
        'J\'ai la possibilité d\'effacer ces notes en cliquant en haut à droite du cadre dans lequel est affichée mon résultat.<br/>Pour éviter de supprimer un devoir par erreur, une confirmation sera demandée à chaque fois.',
        'J\'ai la possibilité de refaire un devoir à volonté tant que celui n\'est pas supprimé, en cliquant sur l\'icône bleue dans le cadre du devoir.<br/><img class="center" src="https://maths-au-quotidien.fr/images/automaths/resultat_fleche.png" alt="fleche">',
        'Je peux voir les notes max et min obtenues ainsi que la moyenne de la classe sur chaque devoir en cliquant sur le logo <span style="color:cadetblue;font-size:1.2em">𝚺</span>.<br/><img class="center" src="https://maths-au-quotidien.fr/images/automaths/resultat_stats.png" alt="fleche">',
        ],
    },
  ]

  const tuto_prof = [
    {
      title: 'Les devoirs donnés aux élèves',
      contain: [
        'Lorsque je supprime un devoir (non optionnel), si au moins 6 élèves ont fait ce devoir, alors la note de zéro est attribuée à ceux du groupe n\'ayant pas fait ce devoir.<br>Les élèves qui ont eu zéro pour devoir non fait ont toujours la possibilité de le rattraper à tout moment (et ainsi améliorer leur moyenne).',
        'Lorsqu\'un professeur envoie un devoir optionnel, les élèves qui ne font pas ce devoir n\'ont pas la note de zéro attribuée lorsque la demande est supprimée. <br>Cela permet de faire passer une série à seulement une partie de la classe, sans pénaliser les autres élèves et donc d\'effectuer une différenciation par notions.',
        'Si des élèves font une série de questions sans que je crée un devoir, les notes sauvegardées ne seront pas visibles dans l\'espace professeur. Ces notes rentreront dans la catégorie "<b>Mes essais</b>" du compte élève et lui seul pourra les voir.<br>Par contre, si un professeur crée un devoir sur la même série faite par des élèves avant que le devoir ne soit donné, alors toutes les notes seront automatiquement comptabilisées dans le devoir donné et le professeur aura accès à ces notes dans son espace.',
      ],
    },
    {
      title: 'Les statistiques élèves',
      contain: [
        'Dans la partie "Quelques Statistiques..." du compte professeur, il est possible de visualiser les résultats obtenus par les élèves des ses classes. <br> Les trois premiers cadres regroupent les moyennes des activités, des essais ainsi que la médiane et l\'écart-type. <br>On visualise les moyennes min et max ainsi que les activités qui correspondent à ces moyennes.',
        'Chaque cadre suivant présente un résumé des statistiques de chaque élève de la classe selectionnée. <br><img src="https://maths-au-quotidien.fr/images/automaths/stat_eleve.png" class="center" width="60%"><br>Dans l\'image précédente, on peut lire que : <br>- Lara a une moyenne de <b><span class="green">63,8 %</span></b>. <br>- Elle a eu 2 fois la note de <b><span class="red">0 %</span></b> (pastille rouge). <br>- En moyenne, elle essaie <span style="color:grey">7 fois</span> les activités. <br>- Elle a obtenu <span  style="color:grey">0 %</span> sur les activités "<b>Distributivité</b>" et "<b>Homothétie</b>". <br>- Sa note maximale est de <span  style="color:grey">80 %</span>, obtenue sur une série de <b>simplifications</b>, que l\'on peut préciser en plaçant le curseur de la souris dessus (<b>Calcul littéral/simplifications</b>). ',
      ],
    },
    {
      title: 'Comment tester un devoir envoyé à mes élèves ?',
      contain: [
        'Lorsque je crée un devoir, il est possible de visualiser des questions qui seront envoyées aux élèves.<br><img src="https://maths-au-quotidien.fr/images/automaths/devoir_creer.png" class="center" width="60%">',
        'Pour cela, il suffit de cliquer sur l\'oeil qui se trouve en haut à droite du cadre.',
        'Les questions s\'affichent. Il est aussi possible de les faire défiler et voir la correction à la fin.',
      ],
    },
    {
      title: 'Générer un nouveau mot de passe élève',
      contain: [
        'Si un élève a perdu son mot de passe et que vous ne l\'avez pas conservé, il est possible de générer un nouveau mot de passe.',
        'Allez dans la partie <b>Gestion</b> puis <b>Générer un mot de passe élève</b>.',
        'Renseignez l\'identifiant de l\'élève sous la forme <b>prenom.nom</b>',
      ],
    },
    {
      title: 'Quelles informations ai-je pour suivre mes élèves ?',
      contain: [
        'Vous disposez d\'informations pour le suivi de vos élèves ',
        'Dans la section <b>Mon espace</b> puis sur l\'onglet d\'une de vos classes :',
        'En cliquant sur ❗, vous avez accès au nombre et à la liste d\'élèves n\'ayant pas réalisé la série.<br> Les élèves qui apparaissent en jaune-orange dans ce cadre sont ceux qui ont testé au moins une fois l\'activité mais sans l\'avoir sauvegardée.<br><img src="https://maths-au-quotidien.fr/images/automaths/info_compte2.png" alt="info suivi élève" class="center" width="40%">',
        'En plaçant le curseur de la souris sur un prénom d\'élève, vous avez accès à plusieurs informations dont le nombre d\'essais réalisés sur la série de questions.<br><img src="https://maths-au-quotidien.fr/images/automaths/info_compte.png" alt="info suivi élève" class="center" width="50%">'
      ],
    },
    {
      title: 'Comment évaluer mes élèves par différenciation ?',
      contain: [
        'Dans la partie <b>Donner</b> de l\'onglet <b>Questions</b>, en bas de page, vous avez la liste de tous vos élèves inscrits dans la classe selectionnée.',
        'Par défaut, tous les élèves sont au <span class="teal"><b>niveau 1</b></span>.',
        'En cliquant sur un élève, vous le basculez au niveau supérieur.',
        'Pour plus de lisibilié, un code couleur est appliqué : <span class="teal"><b>niveau 1</b></span>, <span class="chocolate"><b>niveau 2</b></span>, <span class="purple"><b>niveau 3</b></span>.',
        'Une fois le niveau de chaque élève défini par le professeur, il suffit de cliquer sur le bouton <input type="button" class="btn" value="Mettre à jour"> pour valider ses choix.',
        'Dès lors que les niveaux sont définis, lors de la création d\'un devoir, il suffit de sélectionner le niveau  <span style="color:steelblue;font-weight: bold;">🅳</span> pour que le programme s\'occupe d\'attriubuer le niveau défini à chaque élève.',
      ],
    },
    {
      title: 'Comment proposer mes propres questions ?',
      contain: [
        'Vous souhaiez contribuer au site en proposant des idées de questions ?<br>Il est possible de nous envoyer des questions.',
        'Rendez-vous dans la partie <a href="contact.php">Contactez-nous</a>, puis dans l\'onglet Proposer une question.',
        'Remplir les différents champs (Niveau, chapitre, ...) et ajouter si besoin un fichier (image) pour illustrer votre question.',
        'Cliquer sur envoyer.',
        'CAprès validation de notre part, votre question apparaîtra dans le choix (aléatoire) possible des questions proposées aux élèves.',
      ],
    },
    {
      title: 'Comment supprimer mon compte ?',
      contain: [
        'Quelle qu\'en soit la raison, j\'ai la possibilité de supprimer mon compte.',
        'Je me rends dans la partie <a href="contact.php">Contactez-nous</a>',
        'Renseigner son identifiant ainsi que le numéro d\'identification du compte (pas de mot de passe !!!).',
        'Le compte sera supprimé dans un délai d\'un mois.',
      ],
    },
    ]

  const handleChange = (e) => {
    setSearch(e.target.value)
  }

  function multi_search (needle, haystack) {
    if (needle.includes(' ')) {
      return needle.split(' ').some(elt => clean(haystack).includes(clean(elt)))
    }
    return clean(haystack).includes(clean(needle));
  }

  if(currentUser.profil === 'Professeur') {tuto = tuto.concat(tuto_prof)}

  tuto = tuto.concat([
    {
      title: 'Où puis-je trouver d\'autres informations sur le fonctionnement d\'Automaths ?',
      contain: [
        'Vous pouvez consulter la notice d\'utilisation&nbsp;:<br><a href="https://maths-au-quotidien.fr/automaths-notice.php"><img src="https://maths-au-quotidien.fr/images/notice2.png" alt="notice" class="center"></a>',
      ],
    },
    ])

  //tuto.map((e, k)=> clean(e.title).includes(clean(search)) || e.contain.some(elt=>clean(elt).includes(clean(search))) ? 
  //console.log(multi_search('une + il', 'il était une fois'))
  return (
    <>
      <h1>Tut'<font color="#C8E162">Automaths</font></h1>
      <br/>  
      <input type="text" className="center" id="recherche" placeholder="Recherche rapide" onChange={handleChange} style={{position:'relative',fontSize: "1.1em", left:'50%', textAlign:'center', color:'maroon'}}/> 
      <br/><br/>

      <div className='tuto_container'>
      {
        tuto.map((e, k)=> multi_search(search, e.title) 
                          || e.contain.some(elt=>multi_search(search, elt))
                          || (search.includes('+') ? search.split('+').some(elt => clean(e.title).includes(clean(elt))) && search.split('+').every(elt => clean(e.contain.join('')).includes(clean(elt))) : false)
                          || (search.includes('+') ? search.split('+').every(elt => clean(e.contain.join('')).includes(clean(elt))) : false) ? 
          <span key={k} className="container tuto">
            <h3>{e.title}</h3>
            <ul>
              {e.contain.map((li, key)=><li key={key} dangerouslySetInnerHTML={{ __html:li}}></li>)}
            </ul>
          </span>
          : ''
          )
      }
      </div>
    </>
  );
}